import { render, staticRenderFns } from "./PromotionalBanner.vue?vue&type=template&id=15461196&scoped=true&"
import script from "./PromotionalBanner.vue?vue&type=script&lang=js&"
export * from "./PromotionalBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalBanner.vue?vue&type=style&index=0&id=15461196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15461196",
  null
  
)

component.options.__file = "PromotionalBanner.vue"
export default component.exports